<template>
  <data-table-wrapper
    :filter-config="filterConfig"
    :default-sort="{ by: 'lastName', desc: false }"
    :default-items-per-page="25"
    :enable-search="true"
    :search-config="{
      urlKey: 'search',
      placeholder: 'Suchen...',
      debounce: 300,
    }"
    @filters-changed="onFiltersChanged"
  >
    <template #default="{ filters, updateFilter, searchValue, updateSearch }">
      <v-card elevation="2">
        <v-data-iterator
          :items="normalizedRecords"
          :search="searchValue"
          :custom-filter="filterRecords"
          :footer-props="footerProps"
          :items-per-page="25"
          sort-by="lastName"
          :sort-desc="false"
          :group-by="
            resolvedGroupBy && resolvedGroupBy.value ? '_groupKey' : null
          "
        >
          <template v-slot:header>
            <table-header
              :activeDataViewValue="filters.dataView"
              @active-data-view-updated="updateFilter('dataView', $event)"
              :dataViews="dataViews"
              :searchValue="searchValue"
              @search-updated="updateSearch($event)"
              :groupByItems="groupByItems"
              :groupBySelectorValue="resolvedGroupBy"
              @group-by-selector-updated="updateFilter('groupBy', $event)"
            ></table-header>
          </template>
          <template v-slot:default="props">
            <v-card flat>
              <div
                v-for="(group, groupIndex) in props.groupedItems || [
                  { items: props.items },
                ]"
                :key="groupIndex"
              >
                <template v-if="resolvedGroupBy && resolvedGroupBy.value">
                  <v-divider></v-divider>
                  <v-subheader
                    :class="
                      $vuetify.theme.dark
                        ? 'grey darken-2 font-weight-medium'
                        : 'grey lighten-3 font-weight-medium'
                    "
                    style="height: 32px"
                  >
                    {{ getGroupDisplayName(group.items[0]) }}
                  </v-subheader>
                  <v-divider></v-divider>
                </template>
                <div v-for="(item, index) in group.items" :key="item.user.uid">
                  <v-list-item @click="routeDetails(item)" link>
                    <!-- <v-list-item-avatar size="48">
                    <v-img v-if="item.photoUrl" :src="item.photoUrl"></v-img>
                    <v-avatar
                      v-else
                      :color="
                        $vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-2'
                      "
                    >
                      <span class="white--text text-h6">
                        {{ item.firstName.charAt(0) + item.lastName.charAt(0) }}
                      </span>
                    </v-avatar>
                  </v-list-item-avatar> -->
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{ item.firstName }} {{ item.lastName }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        v-if="
                          item.rank.shortTitle ||
                          item.dutyPosition.shortTitle ||
                          item.personnelNumber ||
                          item.birthdate
                        "
                      >
                        <v-chip outlined label v-if="item.rank.title" small>
                          <img
                            v-if="item.rank.badgeUrl.size70x70"
                            :src="item.rank.badgeUrl.size70x70"
                            contain
                            height="20px"
                            class="mr-2 py-1"
                          />
                          <span class="font-weight-medium">{{
                            item.rank.shortTitle
                          }}</span>
                        </v-chip>

                        <v-chip
                          outlined
                          label
                          v-if="item.dutyPosition.title"
                          small
                          class="ml-2 py-1"
                        >
                          <img
                            v-if="item.dutyPosition.badgeUrl.size70x70"
                            :src="item.dutyPosition.badgeUrl.size70x70"
                            contain
                            height="20px"
                            class="mr-2 py-1"
                          />
                          <span class="font-weight-medium">{{
                            item.dutyPosition.shortTitle
                          }}</span>
                        </v-chip>

                        <div style="line-height: 1.6" class="mb-0 pt-1">
                          <div v-if="item.personnelNumber">
                            <v-icon small left>mdi-identifier</v-icon>
                            {{ item.personnelNumber }}
                          </div>
                          <div v-if="item.birthdate">
                            <v-icon small left>mdi-cake-variant</v-icon>
                            <span
                              :class="
                                getBirthdayColor(item.birthdate.toDate()) +
                                '--text'
                              "
                            >
                              {{ timestampConverter(item.birthdate) }} ({{
                                getAge(item.birthdate.toDate())
                              }})<span v-if="item.birthplace"
                                >, {{ item.birthplace }}</span
                              >
                            </span>
                          </div>
                        </div>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <personnel-record-status-chip :status="item.status" small>
                      </personnel-record-status-chip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index < group.items.length - 1"></v-divider>
                </div>
              </div>
            </v-card>
          </template>
          <template v-slot:no-data>
            <div class="pa-8 text-center">
              <v-icon size="64" color="grey lighten-1"
                >mdi-account-search</v-icon
              >
              <div class="mt-4 text-body-1 grey--text">
                Keine Mitglieder gefunden
              </div>
            </div>
          </template>
        </v-data-iterator>
      </v-card>
    </template>
  </data-table-wrapper>
</template>

<script>
import TableHeader from "@/components/_system/helpers/TableHeader.vue";
import PersonnelRecordStatusChip from "@/components/member-management/personnel-records/PersonnelRecordStatusChip.vue";
import DataTableWrapper from "@/components/_system/DataTableWrapper.vue";
export default {
  name: "personnel-records-list",
  props: {
    personnelRecords: {
      type: Array,
      required: true,
    },
  },
  components: {
    TableHeader,
    PersonnelRecordStatusChip,
    DataTableWrapper,
  },
  data() {
    return {
      filterConfig: {
        dataView: {
          default: "active",
          urlKey: "view",
        },
        groupBy: {
          default: "division.title",
          urlKey: "groupBy",
        },
      },
      currentFilters: {
        dataView: "active",
        groupBy: "division.title",
      },
      dataViews: [
        { text: "Alle", value: "all" },
        { text: "Aktiv", value: "active" },
        { text: "Beurlaubt", value: "onLeave" },
        { text: "Im Übertritt", value: "transfer" },
        { text: "Ausgetreten", value: "resigned" },
        { text: "Entlassen", value: "dismissed" },
        { text: "Verstorben", value: "deceased" },
      ],
      groupByItems: [
        { text: "Abteilung", value: "division.title", icon: "mdi-home-group" },
        {
          text: "Dienstgrad",
          value: "rank.title",
          icon: "mdi-chevron-double-up",
        },
        {
          text: "Dienststellung",
          value: "dutyPosition.title",
          icon: "mdi-account-tie",
        },
        { text: "Status", value: "status", icon: "mdi-account-check" },
      ],
      footerProps: {
        "items-per-page-options": [15, 25, 50, -1],
      },
    };
  },
  computed: {
    // Reconstruct full groupBy object from URL value by matching against groupByItems
    resolvedGroupBy() {
      const groupBy = this.currentFilters.groupBy;

      // Handle null or 'none' explicitly
      if (!groupBy || groupBy === "none") {
        return null;
      }

      // If it's already an object, return it
      if (typeof groupBy === "object" && groupBy.value) {
        return groupBy;
      }

      // If it's a string, find matching item in groupByItems
      if (typeof groupBy === "string") {
        return this.groupByItems.find((item) => item.value === groupBy) || null;
      }

      return null;
    },

    filteredRecords() {
      if (
        !this.currentFilters.dataView ||
        this.currentFilters.dataView === "all"
      ) {
        return this.personnelRecords;
      }
      return this.personnelRecords.filter((record) => {
        return record.status === this.currentFilters.dataView;
      });
    },
    normalizedRecords() {
      return this.filteredRecords.map((record) => {
        const normalized = { ...record };
        const groupBy = this.resolvedGroupBy;
        if (groupBy && groupBy.value) {
          const groupField = groupBy.value;

          if (groupField === "division.title") {
            normalized._groupKey =
              this.getGroupPrefix(record.division) +
              "_" +
              (record.division?.title || "Keine Abteilung");
          } else if (groupField === "rank.title") {
            normalized._groupKey =
              this.getGroupPrefix(record.rank) +
              "_" +
              (record.rank?.title || "Kein Dienstgrad");
          } else if (groupField === "dutyPosition.title") {
            normalized._groupKey =
              this.getGroupPrefix(record.dutyPosition) +
              "_" +
              (record.dutyPosition?.title || "Keine Dienststellung");
          } else if (groupField === "status") {
            normalized._groupKey =
              this.getStatusPrefix(record.status) +
              "_" +
              this.getStatusText(record.status);
          } else {
            const keys = groupField.split(".");
            let value = record;
            for (const key of keys) {
              value = value?.[key];
            }
            normalized._groupKey = value || "__no_group__";
          }
        }
        return normalized;
      });
    },
  },
  methods: {
    filterRecords(items, search) {
      if (!search) return items;
      const searchLower = search.toLowerCase();
      return items.filter((record) => {
        const fullName = `${record.firstName} ${record.lastName}`.toLowerCase();
        const personnelNumber = record.personnelNumber
          ? record.personnelNumber.toLowerCase()
          : "";
        const dutyPosition =
          record.dutyPosition && record.dutyPosition.title
            ? record.dutyPosition.title.toLowerCase()
            : "";
        const rank =
          record.rank && record.rank.title
            ? record.rank.title.toLowerCase()
            : "";
        const division =
          record.division && record.division.title
            ? record.division.title.toLowerCase()
            : "";

        return (
          fullName.includes(searchLower) ||
          personnelNumber.includes(searchLower) ||
          dutyPosition.includes(searchLower) ||
          rank.includes(searchLower) ||
          division.includes(searchLower)
        );
      });
    },
    getAge(birthdate) {
      const today = new Date();
      const birthDate = new Date(birthdate);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
    getDaysUntilBirthday(birthdate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const birthDate = new Date(birthdate);
      const currentYear = today.getFullYear();

      // Create birthday for current year
      const birthdayThisYear = new Date(
        currentYear,
        birthDate.getMonth(),
        birthDate.getDate()
      );
      birthdayThisYear.setHours(0, 0, 0, 0);

      // If birthday already passed this year, check next year
      const birthdayNextYear = new Date(
        currentYear + 1,
        birthDate.getMonth(),
        birthDate.getDate()
      );
      birthdayNextYear.setHours(0, 0, 0, 0);

      const diffThisYear = Math.round(
        (birthdayThisYear - today) / (1000 * 60 * 60 * 24)
      );
      const diffNextYear = Math.round(
        (birthdayNextYear - today) / (1000 * 60 * 60 * 24)
      );

      // Return the closest upcoming birthday
      return Math.abs(diffThisYear) <= Math.abs(diffNextYear)
        ? diffThisYear
        : diffNextYear;
    },
    getBirthdayColor(birthdate) {
      const daysUntil = this.getDaysUntilBirthday(birthdate);
      if (daysUntil === 0) return "red";
      if (Math.abs(daysUntil) <= 7) return "purple";
      return "";
    },
    timestampConverter(timestamp) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    getGroupDisplayName(item) {
      // Strip the sortKey prefix from the _groupKey
      return this.stripPrefix(item._groupKey);
    },
    getGroupPrefix(item) {
      if (!item || !item.sortKey) return "9999";
      return item.sortKey.toString().padStart(4, "0");
    },
    getStatusPrefix(status) {
      const statusOrder = {
        active: "01",
        onLeave: "02",
        transfer: "03",
        resigned: "04",
        dismissed: "05",
        deceased: "06",
      };
      return statusOrder[status] || "99";
    },
    getStatusText(status) {
      const statusText = {
        active: "Aktiv",
        onLeave: "Beurlaubt",
        transfer: "Im Übertritt",
        resigned: "Ausgetreten",
        dismissed: "Entlassen",
        deceased: "Verstorben",
      };
      return statusText[status] || "Unbekannt";
    },
    stripPrefix(groupKey) {
      if (!groupKey) return "";
      const underscoreIndex = groupKey.indexOf("_");
      return underscoreIndex !== -1
        ? groupKey.substring(underscoreIndex + 1)
        : groupKey;
    },
    onFiltersChanged(filters) {
      this.currentFilters = { ...filters };
    },
    updateDataView(value) {
      this.currentFilters.dataView = value;
    },
    updateGroupBySelector(value) {
      // Convert null to 'none' to explicitly indicate no grouping in URL
      this.currentFilters.groupBy = value === null ? "none" : value;
    },
    routeDetails(item) {
      this.$router.push({
        name: "member-management-personnel-records-details-general",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: item.user.uid,
        },
      });
    },
  },
};
</script>
